import { installGutenbergExtensions } from "../index";
import { getSimpleNativePanelsAndTabsForBlock, getSimpleNativePanelsAndTabsRegistry } from "./simple-native-property-internal-shared";
export var NodeMessageSeverity;
(function (NodeMessageSeverity) {
    NodeMessageSeverity[NodeMessageSeverity["info"] = 0] = "info";
    NodeMessageSeverity[NodeMessageSeverity["warning"] = 1] = "warning";
    NodeMessageSeverity[NodeMessageSeverity["error"] = 2] = "error";
})(NodeMessageSeverity || (NodeMessageSeverity = {}));
export function registerSimpleNativeProperties(config) {
    const simpleNativePanelsAndTabs = getSimpleNativePanelsAndTabsRegistry();
    if (Array.isArray(config.block)) {
        for (const b of config.block) {
            addProperties(b, config.properties, simpleNativePanelsAndTabs);
        }
    }
    else {
        addProperties(config.block, config.properties, simpleNativePanelsAndTabs);
    }
}
export function getSimpleNativeProperties(block) {
    const panelsAndTabs = getSimpleNativePanelsAndTabsForBlock(block);
    if (panelsAndTabs === undefined) {
        return undefined;
    }
    const res = [];
    for (const panelOrTab of panelsAndTabs) {
        if ('items' in panelOrTab) {
            for (const item of panelOrTab.items) {
                if ('properties' in item) {
                    res.push(...flattenLaidOutProperties(item.properties));
                }
                else if (Array.isArray(item)) {
                    res.push(...flattenLaidOutProperties(item));
                }
                else {
                    res.push(item);
                }
            }
        }
        else {
            for (const property of panelOrTab.properties) {
                if (Array.isArray(property)) {
                    res.push(...flattenLaidOutProperties(property));
                }
                else {
                    res.push(property);
                }
            }
        }
    }
    return res;
}
function flattenLaidOutProperties(properties) {
    const res = [];
    for (const property of properties) {
        if (Array.isArray(property)) {
            res.push(...flattenLaidOutProperties(property));
        }
        else {
            res.push(property);
        }
    }
    return res;
}
function addProperties(block, properties, simpleNativePanelsAndTabs) {
    const panels = (simpleNativePanelsAndTabs[block] ?? (simpleNativePanelsAndTabs[block] = []));
    if ('title' in properties) {
        panels.push(properties);
        return;
    }
    let rawProperties = [];
    for (const prop of properties) {
        if ('title' in prop) {
            if (rawProperties.length) {
                panels.push({
                    title: "",
                    properties: rawProperties
                });
                rawProperties = [];
            }
            panels.push(prop);
        }
        else {
            rawProperties.push(prop);
        }
    }
    if (rawProperties.length) {
        panels.push({
            title: "",
            properties: rawProperties
        });
    }
}
/**
 * @deprecated use installGutenbergExtensions() instead.
 */
export function installSimpleNativePropertiesSupport() {
    installGutenbergExtensions();
}
//# sourceMappingURL=simple-native-property-api.js.map